import { Avatar, Text } from "@hightouch/htui";

import { ReviewAgentAvatar } from "src/components/comments/review-agent-avatar";

export type MentionOption = {
  /** The target's id, written into the mention node and its body token. */
  value: string;
  label: string;
} & (
  | { kind: "user"; userId: number }
  | { kind: "reviewAgent"; reviewAgentId: string }
  | { kind: "agent" }
);

/** The mention node's attributes; `kind` namespaces the id so the body token can tell a user from an agent. */
export type MentionAttrs = Pick<MentionOption, "kind" | "label"> & {
  id: string;
};

/**
 * The `@` menu's headings, in display order. Agents and people look alike in
 * the list, but tagging an agent asks it for a review instead of notifying someone.
 */
export const MENTION_SECTIONS = ["Agents", "Members"] as const;

type MentionSection = (typeof MENTION_SECTIONS)[number];

/** Which heading an option sits under. */
export function mentionSection(option: MentionOption): MentionSection {
  return option.kind === "user" ? "Members" : "Agents";
}

/** A row in the `@` menu: the avatar, so agents and people read differently, and the name. */
export function renderMentionOption(option: MentionOption) {
  return (
    <>
      {option.kind !== "user" ? (
        <ReviewAgentAvatar name={option.label} size="sm" />
      ) : (
        <Avatar name={option.label} size="sm" hideTooltip />
      )}
      <Text size="sm" color="text.primary">
        {option.label}
      </Text>
    </>
  );
}
